import ETimePicker from '@/components/everridge/ETimePicker';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Control } from 'react-hook-form';
import type { NewOrderFormData } from '@/features/orders/validators/NewOrderValidator';
import OrderApartmentsLookup from '@/features/orders/components/lookups/OrderApartmentsLookup';
import EDatePicker from '@/components/everridge/EDatePicker';
import { cn } from '@/lib/utils';
import useMediaQuery from '@/hooks/useMediaQuery';
import { AppConfig } from '@/config/app.config';

type Props = {
	control: Control<NewOrderFormData>;
	apartmentDisabled?: boolean;
};

const NewOrderDelivery: FC<Props> = ({ control, apartmentDisabled }) => {
	const isMobile = useMediaQuery(AppConfig.mediaQueries.mobile);
	const { t } = useTranslation();

	const today = new Date();

	return (
		<div className='shrink-0 flex flex-col gap-4'>
			<h3 className={cn(isMobile && 'text-base')}>
				{t('main.orders.components.create.components.delivery.title')}
			</h3>
			<div
				className={cn(
					'p-6 grid grid-cols-3 gap-4 border border-popover-100 rounded-2.5xl bg-popover-10',
					isMobile && 'p-0 grid-cols-2 border-0 bg-popover-30',
				)}>
				<div
					className={cn(
						'w-full flex flex-col gap-1.5',
						isMobile && 'col-span-2',
					)}>
					<h5 className={cn(isMobile && 'text-sm')}>
						{t('elements.form.apartments.label2')}
					</h5>
					<OrderApartmentsLookup
						control={control}
						fieldName={'apartmentId'}
						label=''
						disabled={apartmentDisabled}
						placeholder={t('elements.form.apartments.placeholder')}
					/>
				</div>
				<div className='w-full flex flex-col gap-1.5'>
					<h5 className={cn(isMobile && 'text-sm')}>
						{t('elements.form.date.label')}
					</h5>
					<EDatePicker
						control={control}
						fieldName='date'
						align={isMobile ? 'start' : undefined}
						fromDate={today}
						placeholder={t('elements.form.date.placeholder')}
					/>
				</div>
				<div className='w-full flex flex-col gap-1.5'>
					<h5 className={cn(isMobile && 'text-sm')}>
						{t('elements.form.time.label')}
					</h5>
					<ETimePicker
						control={control}
						fieldName='time'
						placeholder={t('elements.form.time.placeholder')}
					/>
				</div>
			</div>
		</div>
	);
};

export default NewOrderDelivery;
